<template>
  <div class="confetti-container" v-if="show">
    <canvas ref="confettiCanvas"></canvas>
  </div>
</template>

<script>
export default {
  name: 'Confetti',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 3000 // 持续时间(ms)
    }
  },
  data() {
    return {
      ctx: null,
      particles: [],
      animationId: null,
      canvasWidth: 0,
      canvasHeight: 0,
      colors: ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5',
               '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4caf50',
               '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800',
               '#ff5722', '#fd6a02']
    }
  },
  mounted() {
    if (this.show) {
      this.$nextTick(() => {
        this.startConfetti()
      })
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.$nextTick(() => {
          this.startConfetti()
        })
      } else {
        this.stopConfetti()
      }
    }
  },
  methods: {
    startConfetti() {
      const canvas = this.$refs.confettiCanvas
      if (!canvas) {
        console.error('Canvas element not found')
        return
      }

      this.canvasWidth = window.innerWidth
      this.canvasHeight = window.innerHeight

      canvas.width = this.canvasWidth
      canvas.height = this.canvasHeight

      this.ctx = canvas.getContext('2d')

      this.particles = []
      const particleCount = 150

      for (let i = 0; i < particleCount; i++) {
        this.particles.push(this.createParticle())
      }

      const startTime = Date.now()
      this.animate(startTime)
    },

    createParticle() {
      return {
        x: Math.random() * this.canvasWidth,
        y: Math.random() * this.canvasHeight - this.canvasHeight,
        size: Math.random() * 8 + 4,
        color: this.colors[Math.floor(Math.random() * this.colors.length)],
        speedY: Math.random() * 3 + 2,
        speedX: Math.random() * 2 - 1,
        rotation: Math.random() * 360,
        rotationSpeed: Math.random() * 10 - 5,
        opacity: Math.random() * 0.5 + 0.5,
        shape: Math.random() > 0.5 ? 'rect' : 'circle'
      }
    },

    animate(startTime) {
      const elapsed = Date.now() - startTime
      if (elapsed > this.duration) {
        this.stopConfetti()
        return
      }

      if (!this.ctx) return

      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)

      this.particles.forEach(particle => {
        particle.y += particle.speedY
        particle.x += particle.speedX
        particle.rotation += particle.rotationSpeed

        if (particle.y > this.canvasHeight) {
          particle.y = -particle.size
          particle.x = Math.random() * this.canvasWidth
        }

        this.ctx.save()
        this.ctx.translate(particle.x, particle.y)
        this.ctx.rotate(particle.rotation * Math.PI / 180)
        this.ctx.globalAlpha = particle.opacity
        this.ctx.fillStyle = particle.color

        if (particle.shape === 'rect') {
          this.ctx.fillRect(-particle.size / 2, -particle.size / 4, particle.size, particle.size / 2)
        } else {
          this.ctx.beginPath()
          this.ctx.arc(0, 0, particle.size / 2, 0, Math.PI * 2)
          this.ctx.fill()
        }

        this.ctx.restore()
      })

      this.animationId = requestAnimationFrame(() => this.animate(startTime))
    },

    stopConfetti() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId)
        this.animationId = null
      }
      if (this.ctx) {
        this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
        this.ctx = null
      }
    }
  },
  beforeDestroy() {
    this.stopConfetti()
  }
}
</script>

<style scoped>
.confetti-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 9999;
  overflow: hidden;
}

.confetti-container canvas {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
